"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("app-listing-link-form", styles.root, className),
        editor: styling_1.mergeStyles("app-listing-link-form-editor", styles.editor),
        editors: styling_1.mergeStyles("app-listing-link-form-editors", styles.editors),
        nameField: styling_1.mergeStyles("app-listing-link-form-name-field", styles.nameField),
        urlField: styling_1.mergeStyles("app-listing-link-form-url-field", styles.urlField),
        removeAction: styling_1.mergeStyles("app-listing-link-form-remove-action", styles.removeAction),
        actions: styling_1.mergeStyles("app-listing-link-form-actions", styles.actions)
    };
});
exports.getClassNames = getClassNames;
